module.exports = __webpack_public_path__ + "img/app-24f0716.png";